import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Button, ButtonToolbar, Row, Tabs, Tab, Col, Input } from 'react-bootstrap';
import Spinner from '../Widgets/spinner';
import { UI_HEIGHT } from '../Common/constants';
import { Translate, Localize } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import moment from 'moment';
import { isOCM, ROOT_URL, isGGI} from '../../actions/root_url';
import { toFromDates } from '../Common/cleanDates';
import axios from 'axios';
import GenericSelection from '../Common/GenericSelection';
import {CUSTOMERS_URL} from '../../actions/url';
import _, { debounce } from 'lodash';

function getBaseUsers(company_id, success) {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/baseuser/users/?company_id=${company_id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).then(res => {
    success(res)
  })
}

///////////////APIS
function inventoryReportExport({ start_date, end_date, warehouse_id }) {

}


const originOptions = [{
  label: 'China',
  value: 'China'
}, {
  label: 'USA',
  value: 'USA',
}, {
  label: 'Egypt',
  value: 'Egypt',
}, {
  label: 'Oman',
  value: 'Oman',
}, {
  label: 'Spain',
  value: 'Spain',
}, {
  label: 'Thailand',
  value: 'Thailand',
}, {
  label: 'Vietnam',
  value: 'Vietnam',
}, {
  label: 'India',
  value: 'India',
}, {
  label: 'Malaysia',
  value: 'Malaysia',
}, {
  label: 'Phillippines',
  value: 'Phillippines'
}, {
  label: 'Indonesia',
  value: 'Indonesia',
}, {
  label: 'Argentina',
  value: 'Argentina',
}, {
  label: 'Ecuador',
  value: 'Ecuador',
}, {
  label: 'Brazil',
  value: 'Brazil',
}, {
  label: 'Honduras',
  value: 'Honduras',
}, {
  label: 'Peru',
  value: 'Peru',
}, {
  label: 'Venezuela',
  value: 'Venezuela',
}, {
  label: 'Chile',
  value: 'Chile',
}, {
  label: 'Taiwan CN',
  value: 'Taiwan CN',
}, {
  label: 'Mexico',
  value: 'Mexico',
}, {
  label: 'Korea',
  value: 'Korea',
}, {
  label: 'Japan',
  value: 'Japan',
}];

const modalStyle = {
  width: '600px',
  height: '420px',
  marginLeft: '-10%',
}

const modalStyle2 = {
  width: '600px',
  height: '620px',
  marginLeft: '-10%',
}

const styles = {
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '5px',
  }
}
class Reports extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };
  constructor() {
    super();
    this.state = {
      salesOptions: [],
      selectedSales: null,
      invoice_start_date: null,
      invoice_end_date: null,

      customerOptions: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null
      },
      includeCustomers: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null
      },
      excluseCustomers: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null
      },
      selectedDays: null,
      brand: null,
      country: null,
      activeKey: 6,
    }
  }

  componentDidMount() {
    let {customerOptions, includeCustomers} = this.state;
    axios.get(
      `${CUSTOMERS_URL}?Company_id=${this.props.company_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      if (response && response.data) {
        response.data.map(r=> {
          customerOptions.rows.push({Name: r.Name, CustomerNum: r.CustomerNum, Customer_id: r.Customer_id});
        });
      }
      this.setState({customerOptions: customerOptions, includeCustomers: customerOptions});
    });
    
    // https://ocm2-scm.truckxi.com/api/v1/customer/?Customer_id__IsActive=1&Company_id=2
    
    // , (err) => {
    //   if (err.status === 500 || err.status === 404) {
    //     err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
    //   }
    //   alert(JSON.stringify(err.data));
    // });

    const success = (res) => {
      this.setState({
        salesOptions: res.data.map(sales => ({
          label: sales.username,
          value: sales.user_id,
        }))
      })
    }
    getBaseUsers(this.props.company_id, success);
  }

  componentWillReceiveProps() {
  }

  handleOnFocus(event) {
    event.target.select();
  }

  renderInvoiceDateRange = (salesInvoiceWithSalesReportExportUrl) => {
    if (isOCM) {
      let invoiceExportParams = ''; 
      if (this.state.invoice_start_date && this.state.invoice_end_date) {
        const { fromDate, toDate } = toFromDates(null, this.state.invoice_start_date, this.state.invoice_end_date);
        invoiceExportParams += `&invoice_start_date=${fromDate}&invoice_end_date=${toDate}`;
      }
      return <div style={{ paddingLeft: '7px', paddingTop: '12px' }}>
        <Row><Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
          <div style={styles.fieldContainer}>
            <label>
              <Translate value="expired_date" />
              <span>:</span>
            </label>
            <DateTimePicker
              format="MM-DD-YY"
              time={false}
              onChange={(timestamp) => this.setState({
                start_date2: timestamp
              })}
              value={this.state.start_date2}
            />
          </div>
        </Col>
        <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
          <div style={styles.fieldContainer}>
            <label>
              <Translate value="end_date" />
              <span>:</span>
            </label>
            <DateTimePicker
              format="MM-DD-YY"
              time={false}
              onChange={(timestamp) => this.setState({
                end_date2: timestamp
              })}
              value={this.state.end_date2}
            />
          </div>
        </Col></Row>
        <Row>
          <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
            <div style={styles.fieldContainer}>
              <label>
                <Translate value="invoice_start_date" />
                <span>:</span>
              </label>
              <DateTimePicker
                format="MM-DD-YY"
                time={false}
                onChange={(timestamp) => this.setState({
                  invoice_start_date: timestamp
                })}
                value={this.state.invoice_start_date}
              />
            </div>
          </Col>
          <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
            <div style={styles.fieldContainer}>
              <label>
                <Translate value="invoice_end_date" />
                <span>:</span>
              </label>
              <DateTimePicker
                format="MM-DD-YY"
                time={false}
                onChange={(timestamp) => this.setState({
                  invoice_end_date: timestamp
                })}
                value={this.state.invoice_end_date}
              />
            </div>
          </Col>
          <Button
            bsStyle="success"
            type="button"
            style={{ marginTop: '25px' }}
            disabled={!this.state.selectedSales || !this.state.start_date2 || !this.state.end_date2}
            href={salesInvoiceWithSalesReportExportUrl + invoiceExportParams}
          >
            <em className="fa fa-download" /><Translate value="export" />
          </Button>
        </Row>
      </div>
    }
    return <Row>
      <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
        <div style={styles.fieldContainer}>
          <label>
            <Translate value="start_date" />
            <span>:</span>
          </label>
          <DateTimePicker
            format="MM-DD-YY"
            time={false}
            onChange={(timestamp) => this.setState({
              start_date2: timestamp
            })}
            value={this.state.start_date2}
          />
        </div>
      </Col>
      <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
        <div style={styles.fieldContainer}>
          <label>
            <Translate value="end_date" />
            <span>:</span>
          </label>
          <DateTimePicker
            format="MM-DD-YY"
            time={false}
            onChange={(timestamp) => this.setState({
              end_date2: timestamp
            })}
            value={this.state.end_date2}
          />
        </div>
      </Col>
      <Button
        bsStyle="success"
        type="button"
        style={{ marginTop: '25px' }}
        disabled={!this.state.selectedSales || !this.state.start_date2 || !this.state.end_date2}
        href={salesInvoiceWithSalesReportExportUrl}
      >
        <em className="fa fa-download" /><Translate value="export" />
      </Button>
    </Row>
  }

  render() {
    const { fromDate, toDate } = toFromDates(this.state.selectedDays, this.state.start_date, this.state.end_date);
    const dateRange2 = toFromDates(null, this.state.start_date2, this.state.end_date2);

    let {customerOptions, includeCustomers, excluseCustomers, activeKey, selectedDays, country, brand} = this.state;
    const columns = [
      {
          key: 'Name',
          name: <Translate value="name" />,
          resizable: true,
          width: 280,
          sortable: true,
          filterable: true
      },
      {
        key: 'CustomerNum',
        name: <Translate value="cust_num" />,
        resizable: true,
        width: 150,
        sortable: true,
        filterable: true
    },
    ];

    const daysOptions = [
      {
        label: '7 Days', value: 7
      },
      {
        label: '30 Days', value: 30
      },
      {
        label: '90 Days', value: 90
      },
    ]


    const getRows1 = () => {
      return Data.Selectors.getRows(this.state.includeCustomers);
  }

  const getSize1 = () => {
      return getRows1().length;
  }

  const rowGetter1 = rowIdx => {
      var rows = getRows1();
      return rows[rowIdx];
  }

  const handleGridSort1 = (sortColumn, sortDirection) => {
    const state = Object.assign({}, this.state.includeCustomers, {
      sortColumn,
      sortDirection,
    });
    this.setState({ includeCustomers: state });
  };

  const handleFilterChange1 = debounce(
    (filter) => {
      this.state.includeCustomers.rows = this.state.customerOptions.rows;
      // this.state.includeCustomers.selectedRows = [];
      const newFilters = Object.assign({}, this.state.includeCustomers.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const includeCustomers = { ...this.state.includeCustomers, filters: newFilters };
      this.setState({ includeCustomers });
    },
    500,
    { maxWait: 800 },
  );

const onRowsSelected = (rows) => {
  // this.setState({
  //   scrollTopPositionIndex: rows[0].rowIdx,
  // });
  const newRows = getRows1();
  const selectedRows = [...this.state.includeCustomers.selectedRows];
  rows.map((r) => {
    newRows[r.rowIdx].isSelected = true;
    selectedRows.push(r.row);
  });
  const includeCustomers = {
    ...this.state.includeCustomers,
    rows: newRows,
    selectedRows,
  };
  this.setState({ includeCustomers });
};

const onRowsDeselected = (rows) => {
  const newRows = [...this.state.includeCustomers.rows];
  const selectedRows = [...this.state.includeCustomers.selectedRows];
  rows.map((r) => {
    newRows[r.rowIdx].isSelected = false;
    const rowIndex = selectedRows.indexOf(r.row);
    selectedRows.splice(rowIndex, 1);
  });
  const includeCustomers = {
    ...this.state.includeCustomers,
    rows: newRows,
    selectedRows,
  };
  this.setState({ includeCustomers });
};

const onRowClick1 = (rowIdx, row) => {

}


const getRows2 = () => {
  return Data.Selectors.getRows(this.state.excluseCustomers);
}

const getSize2 = () => {
  return getRows2().length;
}

const rowGetter2 = rowIdx => {
  var rows = getRows1();
  return rows[rowIdx];
}

const handleGridSort2 = (sortColumn, sortDirection) => {
var excluseCustomers = Object.assign({}, this.state.excluseCustomers, { sortColumn: sortColumn, sortDirection: sortDirection });
this.setState({excluseCustomers});
}

const handleFilterChange2 = filter => {
let newFilters = Object.assign({}, this.state.excluseCustomers.filters);
if (filter.filterTerm) {
    newFilters[filter.column.key] = filter;
} else {
    delete newFilters[filter.column.key];
}
const excluseCustomers = {...this.state.excluseCustomers, filters: newFilters};
this.setState({ excluseCustomers });
}

const onRowClick2 = (rowIdx, row) => {
//  this.props.fetchUserDetail(row.user_id);
}

const refreshCustomers = () => {
  let {customerOptions} = this.state;
  excluseCustomers = {
    rows: [],
    selectedRows: [],
    filters: {},
    sortColumn: null,
    sortDirection: null
  },
  this.setState({includeCustomers: customerOptions, excluseCustomers: excluseCustomers});
}



  const handleSelect = (activeKey) => {
    this.setState({ activeKey });
  }

  const selectDays = (selectedDays) => {
    this.setState({ selectedDays, start_date: null, end_date: null });
  }

  const selectCountry = (country) => {
    this.setState({ country });
  }

  let selectedString = '';
  let selectedCustIds = [];
  if (this.state.includeCustomers && this.state.includeCustomers.selectedRows && this.state.includeCustomers.selectedRows.length > 0) {
    this.state.includeCustomers.selectedRows.map(r=>{
      selectedCustIds.push(r.Customer_id);
    });
    selectedString = selectedCustIds.join(",");
  }
    const warehouse_id = this.props.warehouse_id;
    const company_id = this.props.company_id;
    const token = localStorage.getItem('token');
    let inventoryReportExportUrl = `${ROOT_URL}v1/statistics/download_inventory_by_expire_date?warehouse_id=${warehouse_id}&start_date=${fromDate}&end_date=${toDate}&Bearer=${token}`
    let purchaseOrderReportExportUrl = `${ROOT_URL}v1/statistics/purchase_order?warehouse_id=${warehouse_id}&start_date=${fromDate}&end_date=${toDate}&date_type=post_datetime&Bearer=${token}`
    let salesInvoiceReportExportUrl = `${ROOT_URL}v1/statistics/sales_invoice?warehouse_id=${warehouse_id}&start_date=${fromDate}&end_date=${toDate}&date_type=post_datetime&Bearer=${token}`
    const salesInvoiceWithSalesReportExportUrl = `${ROOT_URL}v1/statistics/download_sales_invoice_quantity_by_sales?warehouse_id=${warehouse_id}&company_id=${company_id}&start_date=${dateRange2.fromDate}&end_date=${dateRange2.toDate}&sales_id=${this.state.selectedSales && this.state.selectedSales.value}&Bearer=${token}`
    const driverDispatchReportUrl = `${ROOT_URL}v1/statistics/driver_dispatch_report?warehouseId=${warehouse_id}&companyId=${company_id}&start_date=${fromDate}&end_date=${toDate}&Bearer=${token}`
    const qbReportUrl = `${ROOT_URL}v1/quickbook/export_failed_data?company_id=${company_id}`
    const dsiReportUrl = `${ROOT_URL}v1/statistics/dsi_report?company_id=${company_id}&warehouse_id=${warehouse_id}&start_date=${fromDate}&end_date=${toDate}&Bearer=${token}&exclude_customer=${selectedString}&country=${country}&brand=${brand}`
    if (isGGI) {
      inventoryReportExportUrl += `&company_id=${company_id}`;
      purchaseOrderReportExportUrl += `&company_id=${company_id}`;
      salesInvoiceReportExportUrl += `&company_id=${company_id}`;
    }
// &exclude_customer=${selectedString}
    // /statistics/dsi_report?company_id=3&warehouse_id=8&start_date=2023-03-05T07:00:00.000Z&end_date=2023-06-06T06:59:59.999Z&exclude_customer=1478,1484
    return (
      <ContentWrapper>
        <Row>
          <Col sm={12}>
            <Tabs onSelect={handleSelect} justified activeKey={this.state.activeKey}>
              <Tab eventKey={1} title={'Inventory Report'}>
                <Row>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="start_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          start_date: timestamp
                        })}
                        value={this.state.start_date}
                      />
                    </div>
                  </Col>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="end_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          end_date: timestamp
                        })}
                        value={this.state.end_date}
                      />
                    </div>
                  </Col>
                  <Button
                    bsStyle="success"
                    type="button"
                    style={{ marginTop: '25px' }}
                    disabled={!this.state.start_date || !this.state.end_date}
                    // onClick={() => {
                    //   inventoryReportExport({
                    //     start_date, end_date, warehouse_id,
                    //   })
                    // }}
                    href={inventoryReportExportUrl}
                  >
                    <em className="fa fa-download" /><Translate value="export" />
                  </Button>
                </Row>
                <span style={{ color: 'red' }}>
                  <Translate value={isGGI ? "report_modal_annotation1_special" : "report_modal_annotation1"} />
                </span>
              </Tab>
              <Tab eventKey={2} title={'Purchase Order Report'}>
                <Row>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="start_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          start_date: timestamp
                        })}
                        value={this.state.start_date}
                      />
                    </div>
                  </Col>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="end_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          end_date: timestamp
                        })}
                        value={this.state.end_date}
                      />
                    </div>
                  </Col>
                  <Button
                    bsStyle="success"
                    type="button"
                    style={{ marginTop: '25px' }}
                    disabled={!this.state.start_date || !this.state.end_date}
                    href={purchaseOrderReportExportUrl}
                  >
                    <em className="fa fa-download" /><Translate value="export" />
                  </Button>
                </Row>
                <span style={{ color: 'red' }}>
                  <Translate value="report_modal_annotation2" />
                </span>
              </Tab>
              <Tab eventKey={3} title={'Sales Invoice Report'}>
                <Row>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="start_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          start_date: timestamp
                        })}
                        value={this.state.start_date}
                      />
                    </div>
                  </Col>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="end_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          end_date: timestamp
                        })}
                        value={this.state.end_date}
                      />
                    </div>
                  </Col>
                  <Button
                    bsStyle="success"
                    type="button"
                    style={{ marginTop: '25px' }}
                    disabled={!this.state.start_date || !this.state.end_date}
                    href={salesInvoiceReportExportUrl}
                  >
                    <em className="fa fa-download" /><Translate value="export" />
                  </Button>
                </Row>
                <span style={{ color: 'red' }}>
                  <Translate value="report_modal_annotation3" />
                </span>
                <br />
                <br />
                <Row>
                  <Col>
                    <div style={styles.fieldContainer} id="reportsModal">
                      <label>
                        <Translate value="sales" />
                        <span>:</span>
                      </label>
                      <GenericSelection
                        options={this.state.salesOptions}
                        value={this.state.selectedSales}
                        setSelected={(selectedSales) => { this.setState({ selectedSales }); }}
                      />
                    </div>
                  </Col>
                  {this.renderInvoiceDateRange(salesInvoiceWithSalesReportExportUrl)}
                </Row>
                <span style={{ color: 'red' }}>
                  <Translate value="report_modal_annotation3_sales" />
                </span>
              </Tab>
              <Tab eventKey={4} title={'Driver Dispatch Report'}>
                <Row>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="start_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          start_date: timestamp
                        })}
                        value={this.state.start_date}
                      />
                    </div>
                  </Col>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="end_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          end_date: timestamp
                        })}
                        value={this.state.end_date}
                      />
                    </div>
                  </Col>
                  <Button
                    bsStyle="success"
                    type="button"
                    style={{ marginTop: '25px' }}
                    disabled={!this.state.start_date || !this.state.end_date}
                    href={driverDispatchReportUrl}
                  >
                    <em className="fa fa-download" /><Translate value="export" />
                  </Button>
                </Row>
                <span style={{ color: 'red' }}>
                  {/* <Translate value="report_modal_annotation3" /> */}
                </span>
              </Tab>
              <Tab eventKey={5} title={'QB Report'}>
                <Row>
                  {/* <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="start_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          start_date: timestamp
                        })}
                        value={this.state.start_date}
                      />
                    </div>
                  </Col>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="end_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          end_date: timestamp
                        })}
                        value={this.state.end_date}
                      />
                    </div>
                  </Col> */}
                  <Button
                    bsStyle="success"
                    type="button"
                    style={{ marginTop: '25px' }}
                    // disabled={}
                    href={qbReportUrl}
                  >
                    <em className="fa fa-download" /><Translate value="export" />
                  </Button>
                </Row>
                <span style={{ color: 'red' }}>
                  {/* <Translate value="report_modal_annotation3" /> */}
                </span>
              </Tab>



              <Tab eventKey={6} title={'DSI Report'}>
                <Row>
                <Col xs={3} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                <div style={styles.fieldContainer} className="reports-dropship">
                      <label>
                        <Translate value="days" />
                        <span>:</span>
                      </label>
                      <GenericSelection
                        options={daysOptions}
                        value={this.state.selectedDays}
                        setSelected={(selectedDays) => { selectDays( selectedDays.value );  }}
                      />
                    </div>
                  </Col>
                  <Col xs={3} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="start_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          start_date: timestamp,
                          selectedDays: null,
                        })}
                        value={this.state.start_date}
                      />
                    </div>
                  </Col>
                  <Col xs={3} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                    <div style={styles.fieldContainer}>
                      <label>
                        <Translate value="end_date" />
                        <span>:</span>
                      </label>
                      <DateTimePicker
                        format="MM-DD-YY"
                        time={false}
                        onChange={(timestamp) => this.setState({
                          end_date: timestamp,
                          selectedDays: null,
                        })}
                        value={this.state.end_date}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                <div style={styles.fieldContainer} className="reports-dropship">
                      <label>
                        <Translate value="brand" />
                        <span>:</span>
                      </label>
                      <Input
                                    type="text"
                                    name="brand"
                                    value={this.state.brand}
                                    onChange={(e) => {
                                      this.setState({ brand: e.target.value });
                                    }}
                                  />
                    </div>
                  </Col>
                  <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
                <div style={styles.fieldContainer} className="reports-dropship">
                      <label>
                        <Translate value="country" />
                        <span>:</span>
                      </label>
                      <GenericSelection
                        options={originOptions}
                        value={this.state.country}
                        setSelected={(country) => { selectCountry( country.value );  }}
                      />                    
                      </div>
                  </Col>
                  <Button
                    bsStyle="success"
                    type="button"
                    style={{ marginTop: '25px' }}
                    disabled={(!this.state.start_date || !this.state.end_date) && !this.state.selectedDays}
                    href={dsiReportUrl}
                  >
                    <em className="fa fa-download" /><Translate value="export" />
                  </Button>
                </Row>





                { true &&
<div style={{position: 'absolute', marginTop: '5px'}}> 
<p style={{fontSize: '14px'}}>Exclude Customers:</p>
{/* <Button
                    bsStyle="success"
                    type="button"
                    // style={{ marginTop: '25px' }}
                     onClick={() => {
                      refreshCustomers()
                    }}
                    // disabled={}
                  >
                    <Translate value="reload" />
                  </Button> */}
                  </div>
  }
                  {true && 
<Row>
<Col sm={ 12 }><div style={{ maxWidth: '100%', marginTop: '0px' }} className="group-permission-data-grid" id="UserManagementDetail-dataGrid3">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort1}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange1}
                        columns={columns}
                        rowHeight={25}
                        minHeight={300}
                        rowGetter={rowGetter1}
                        rowsCount={ getSize1() }
                        // onRowClick={onRowClick1}
                        enableRowSelect="multi"
                        rowSelection={{
                          showCheckbox: true,
                          enableShiftSelect: true,
                          onRowsSelected,
                          onRowsDeselected,
                          selectBy: {
                            isSelectedKey: "isSelected",
                          },
                        }}
                       />
                </div></Col>
                {/* <Col sm={ 6 }><div style={{ maxWidth: '100%', marginTop: '10px' }} className="group-permission-data-grid" id="UserManagementDetail-dataGrid3">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort2}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange2}
                        columns={columns}
                        rowHeight={25}
                        minHeight={300}
                        rowGetter={rowGetter2}
                        rowsCount={ getSize2() }
                        onRowClick={onRowClick2}
                       />
                </div></Col> */}
</Row>
  }
                {/* <span style={{ color: 'red' }}>
                  <Translate value="report_modal_annotation3" />
                </span> */}
              </Tab>





            </Tabs>
          </Col>
        </Row>
      </ContentWrapper>
    )
  }
}

const ReportsModal = ({ isVisible, setModalVisibility, warehouse_id, company_id }) => (
  <SkyLightStateless
    title={'Reports Export'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle2}
    isVisible={isVisible}
  >
    <Reports setModalVisibility={setModalVisibility} warehouse_id={warehouse_id} company_id={company_id} />
  </SkyLightStateless>
)

// ReportsModal.propTypes = propTypes
// ReportsModal.defaultProps = defaultProps

export default ReportsModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/ReportsModal.jsx